<div class="customer-promo-page">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Promo Codes</span>

      <h1>Beauty <span>Savings</span></h1>

      <p>
        Claim, redeem, and manage your available beauty vouchers from one clean
        savings center.
      </p>
    </div>

    <div class="hero-actions">
      <div class="redeem-box">
        <input
          type="text"
          placeholder="Enter promo code"
          [(ngModel)]="promoCode"
          [class.is-invalid]="promoIsNull"
          (keyup.enter)="redeemPromoVouchers(promoCode)"
        />

        <button
          type="button"
          class="overview-btn overview-btn--dark"
          (click)="redeemPromoVouchers(promoCode)"
        >
          Redeem
        </button>
      </div>
    </div>
  </section>

  <section class="kpi-grid">
    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Vouchers</span>
        <strong>{{ promoVouchers.length }}</strong>
        <p>Promo codes currently available in your account.</p>
      </div>

      <img [src]="assetUrl + 'icons/doc-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Active</span>
        <strong>{{ activeVouchers }}</strong>
        <p>Vouchers currently marked as active or usable.</p>
      </div>

      <img [src]="assetUrl + 'icons/review-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Expired</span>
        <strong>{{ expiredVouchers }}</strong>
        <p>Promos with an end date before today.</p>
      </div>

      <img [src]="assetUrl + 'icons/calendar-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Highest Value</span>
        <strong>{{ highestVoucherValue }}</strong>
        <p>Best visible discount in your voucher list.</p>
      </div>

      <img [src]="assetUrl + 'icons/dollar-border.svg'" alt="" />
    </article>
  </section>

  <section class="metric-grid">
    <article class="metric-card metric-card--success">
      <span>Percentage Deals</span>
      <strong>{{ percentageVouchers }}</strong>
      <p>Discounts based on a percentage value.</p>
    </article>

    <article class="metric-card">
      <span>Fixed Deals</span>
      <strong>{{ fixedVouchers }}</strong>
      <p>Discounts based on a fixed dollar value.</p>
    </article>

    <article class="metric-card metric-card--warning">
      <span>Ending Soon</span>
      <strong>{{ endingSoonVouchers }}</strong>
      <p>Promos ending within the next 14 days.</p>
    </article>
  </section>

  <section class="panel">
    <header class="panel-head">
      <div>
        <span class="panel-kicker">Voucher Wallet</span>
        <h2>Your Vouchers</h2>
        <p>
          Browse your redeemed and available vouchers. Use the promo box above
          to claim a new discount code.
        </p>
      </div>

      <span class="count-pill">{{ promoVouchers.length }} vouchers</span>
    </header>

    @if (promoIsNull) {
      <div class="inline-alert">
        Please enter a promo code before redeeming.
      </div>
    }

    @if (!isLoading && promoVouchers.length === 0) {
      <div class="empty-state">
        <div class="empty-icon">
          <span>%</span>
        </div>

        <strong>No promo codes yet</strong>

        <p>
          When you redeem promo codes or receive vouchers, they will appear here
          for quick access.
        </p>
      </div>
    } @else {
      <div class="voucher-grid">
        <article
          *ngFor="let voucher of promoVouchers; trackBy: trackByVoucherID"
          class="voucher-card"
        >
          <div class="voucher-top">
            <div class="voucher-badge">
              {{ formatDiscountValue(voucher) }}
            </div>

            <span class="status-pill" [ngClass]="voucherStatusClass(voucher)">
              {{ voucherStatusLabel(voucher) }}
            </span>
          </div>

          <div class="voucher-main">
            <span class="panel-kicker">Promo Code</span>

            <h3>{{ voucher.name || "Beauty Discount" }}</h3>

            <p>
              {{
                voucher.service_name ||
                  voucher.service?.name ||
                  "Eligible service discount"
              }}
            </p>
          </div>

          <div class="voucher-code-row">
            <span>{{ voucher.code || "NO CODE" }}</span>

            <button
              type="button"
              class="copy-btn"
              (click)="copyPromoCode(voucher.code)"
            >
              Copy
            </button>
          </div>

          <div class="voucher-meta">
            <span>
              Starts {{ formatDate(voucher.start_date) || "Anytime" }}
            </span>

            <span>
              Ends {{ formatDate(voucher.end_date) || "No expiry" }}
            </span>
          </div>
        </article>
      </div>
    }
  </section>
</div>
